module.exports = __webpack_public_path__ + "8a225636682c5900f459cf229072983b.svg";